"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBT_SWAP_ACTIVATION_REQUIREMENT_TYPES = exports.isHomePurchaseSettlementActivationRequirementType = exports.isAvenTransferActivationRequirementType = exports.isCashOutUpfrontActivationRequirementType = exports.isDebtSwapActivationRequirementType = exports.HELOC_REFI_ACTIVATION_REQUIREMENT_TYPES = exports.isHelocRefiActivationRequirementType = exports.AccountActivationRequirementType = exports.NON_TERMINAL_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES = exports.TERMINAL_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES = exports.INCOMPLETE_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES = exports.ACTIVATION_REQUIREMENT_STATUSES_REQUIRING_DEBT_SWAP_BALANCE_TRANSFER_REGISTRATION = exports.AccountActivationRequirementStatus = void 0;
const lodash_1 = __importDefault(require("lodash"));
const assertUtils_1 = require("../assertUtils");
/** @TranslateToPython */
var AccountActivationRequirementStatus;
(function (AccountActivationRequirementStatus) {
    AccountActivationRequirementStatus["pending"] = "pending";
    AccountActivationRequirementStatus["inProgress"] = "inProgress";
    AccountActivationRequirementStatus["waitingToClear"] = "waitingToClear";
    AccountActivationRequirementStatus["complete"] = "complete";
    AccountActivationRequirementStatus["bypassed"] = "bypassed";
    AccountActivationRequirementStatus["canceled"] = "canceled";
})(AccountActivationRequirementStatus || (exports.AccountActivationRequirementStatus = AccountActivationRequirementStatus = {}));
// If we are already waiting to clear, we don't need to register debt swap balance transfer again
exports.ACTIVATION_REQUIREMENT_STATUSES_REQUIRING_DEBT_SWAP_BALANCE_TRANSFER_REGISTRATION = [AccountActivationRequirementStatus.pending, AccountActivationRequirementStatus.inProgress];
exports.INCOMPLETE_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES = [
    AccountActivationRequirementStatus.pending,
    AccountActivationRequirementStatus.inProgress,
    AccountActivationRequirementStatus.waitingToClear,
];
exports.TERMINAL_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES = [AccountActivationRequirementStatus.complete, AccountActivationRequirementStatus.bypassed, AccountActivationRequirementStatus.canceled];
exports.NON_TERMINAL_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES = Object.values(AccountActivationRequirementStatus).filter((status) => !exports.TERMINAL_ACCOUNT_ACTIVATION_REQUIREMENT_STATUSES.includes(status));
var AccountActivationRequirementType;
(function (AccountActivationRequirementType) {
    AccountActivationRequirementType["fixedTermCashOutUpfront"] = "fixedTermCashOutUpfront";
    AccountActivationRequirementType["fixedTermCashOutUpfrontDebtSwap"] = "fixedTermCashOutUpfrontDebtSwap";
    AccountActivationRequirementType["fixedTermCashOutUpfrontHelocRefi"] = "fixedTermCashOutUpfrontHelocRefi";
    AccountActivationRequirementType["fixedTermCashOutUpfrontHelocRefiDebtSwap"] = "fixedTermCashOutUpfrontHelocRefiDebtSwap";
    AccountActivationRequirementType["homePurchaseSettlement"] = "homePurchaseSettlement";
    /**
     * @deprecated cashOutUpfrontV1 has been deprecated, newer upfront should use 'fixedTermCashOutUpfront' type
     */
    AccountActivationRequirementType["_cashOutUpfrontV1"] = "cashOutUpfrontV1";
    /**
     * @deprecated cashOutUpfrontV2 has been deprecated, newer upfront should use 'fixedTermCashOutUpfront' type
     */
    AccountActivationRequirementType["_cashOutUpfrontV2"] = "cashOutUpfrontV2";
})(AccountActivationRequirementType || (exports.AccountActivationRequirementType = AccountActivationRequirementType = {}));
const isHelocRefiActivationRequirementType = (type) => {
    if (lodash_1.default.isNil(type)) {
        return false;
    }
    switch (type) {
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefi:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefiDebtSwap:
            return true;
        case AccountActivationRequirementType.fixedTermCashOutUpfront:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontDebtSwap:
        case AccountActivationRequirementType.homePurchaseSettlement:
        case AccountActivationRequirementType._cashOutUpfrontV1:
        case AccountActivationRequirementType._cashOutUpfrontV2:
            return false;
        default:
            throw (0, assertUtils_1.assertNever)(type, `unhandled AccountActivationRequirementType ${type}`);
    }
};
exports.isHelocRefiActivationRequirementType = isHelocRefiActivationRequirementType;
exports.HELOC_REFI_ACTIVATION_REQUIREMENT_TYPES = Object.values(AccountActivationRequirementType).filter((type) => (0, exports.isHelocRefiActivationRequirementType)(type));
const isDebtSwapActivationRequirementType = (type) => {
    if (lodash_1.default.isNil(type)) {
        return false;
    }
    switch (type) {
        case AccountActivationRequirementType.fixedTermCashOutUpfrontDebtSwap:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefiDebtSwap:
            return true;
        case AccountActivationRequirementType.fixedTermCashOutUpfront:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefi:
        case AccountActivationRequirementType.homePurchaseSettlement:
        case AccountActivationRequirementType._cashOutUpfrontV1:
        case AccountActivationRequirementType._cashOutUpfrontV2:
            return false;
        default:
            throw (0, assertUtils_1.assertNever)(type, `unhandled AccountActivationRequirementType ${type}`);
    }
};
exports.isDebtSwapActivationRequirementType = isDebtSwapActivationRequirementType;
const isCashOutUpfrontActivationRequirementType = (type) => {
    if (lodash_1.default.isNil(type)) {
        return false;
    }
    switch (type) {
        case AccountActivationRequirementType.fixedTermCashOutUpfront:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefi:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontDebtSwap:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefiDebtSwap:
        case AccountActivationRequirementType._cashOutUpfrontV1:
        case AccountActivationRequirementType._cashOutUpfrontV2:
            return true;
        case AccountActivationRequirementType.homePurchaseSettlement:
            return false;
        default:
            throw (0, assertUtils_1.assertNever)(type, `unhandled AccountActivationRequirementType ${type}`);
    }
};
exports.isCashOutUpfrontActivationRequirementType = isCashOutUpfrontActivationRequirementType;
const isAvenTransferActivationRequirementType = (type) => {
    if (lodash_1.default.isNil(type)) {
        return false;
    }
    switch (type) {
        case AccountActivationRequirementType.fixedTermCashOutUpfront:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefi:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontDebtSwap:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefiDebtSwap:
        case AccountActivationRequirementType._cashOutUpfrontV1:
        case AccountActivationRequirementType._cashOutUpfrontV2:
            return true;
        case AccountActivationRequirementType.homePurchaseSettlement:
            return false;
        default:
            throw (0, assertUtils_1.assertNever)(type, `unhandled AccountActivationRequirementType ${type}`);
    }
};
exports.isAvenTransferActivationRequirementType = isAvenTransferActivationRequirementType;
const isHomePurchaseSettlementActivationRequirementType = (type) => {
    if (lodash_1.default.isNil(type)) {
        return false;
    }
    switch (type) {
        case AccountActivationRequirementType.homePurchaseSettlement:
            return true;
        case AccountActivationRequirementType.fixedTermCashOutUpfront:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefi:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontDebtSwap:
        case AccountActivationRequirementType.fixedTermCashOutUpfrontHelocRefiDebtSwap:
        case AccountActivationRequirementType._cashOutUpfrontV1:
        case AccountActivationRequirementType._cashOutUpfrontV2:
            return false;
        default:
            throw (0, assertUtils_1.assertNever)(type, `unhandled AccountActivationRequirementType ${type}`);
    }
};
exports.isHomePurchaseSettlementActivationRequirementType = isHomePurchaseSettlementActivationRequirementType;
exports.DEBT_SWAP_ACTIVATION_REQUIREMENT_TYPES = Object.values(AccountActivationRequirementType).filter((type) => (0, exports.isDebtSwapActivationRequirementType)(type));
